import { Box, Typography } from '@mui/material'

const CommonRadioButton = ({ label, checked, onChange }) => {
  return (
    <Box
      onClick={onChange}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          border: `2px solid ${checked ? 'var(--forbrand-color)' : 'var(--border-strong)'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {checked && (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: 'var(--forbrand-color)',
            }}
          />
        )}
      </Box>
      <Typography
        sx={{
          fontSize: 'var(--font-size-sm)',
          color: 'var(--forbrand-primary)',
          fontWeight: 400,
          userSelect: 'none',
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default CommonRadioButton
